import validators from '../../../utils/validators';
import DrugManufacturer from '../manufacturer';
import DrugStock from '../stock';

class DrugPrescriptionAnalog {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      name: (v) => validators.isNotEmptyString(v),
      measure: (v) => validators.isNumberOrNull(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid DrugPrescriptionAnalog property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }

    try {
      this.manufacturer = new DrugManufacturer(data.manufacturer);
      this.stocks = data.stocks.map(i => new DrugStock(i));
    } catch (e) {
      throw new Error(`Error in DrugPrescriptionAnalog in ${data.id}: ${e.message}`);
    }
  }
}

export default DrugPrescriptionAnalog;
